import React, { PropTypes } from 'react';
import Images from './Images';
import ArticleText from './ArticleText';
import classNames from 'classnames';
import { findImagesPosition, isCarousel } from '../utils';

const Fiche = ({ item, lang }) => (
  <div className="fiche">
    <div className={classNames(findImagesPosition(item))}>
      {item.has('images') && <Images
        lang={lang}
        item={item.delete('texte').delete('title').delete('subtitle')}
        position={findImagesPosition(item)}
        carousel={isCarousel(item)}
      />}
    </div>
    <ArticleText lang={lang} item={item} />
  </div>
);

Fiche.propTypes = {
  lang: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
};

export default Fiche;



// WEBPACK FOOTER //
// ./common/components/Fiche.js